/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc
 */

export const getEnrolledPromotionsByPortalIdRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'getEnrolledPromotionsByPortalId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA7DrFM4EinG0xxMJ3k-I7t',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enrollPortalRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'enrollPortal',
  auth: 'app',
  fingerprint: 'kDy34H8e9fdQToJxBlwHXHf642x2d6yP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkEnrollPortalRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'bulkEnrollPortal',
  auth: 'app',
  fingerprint: 'wELJHLAnnaUzrP_8283sxXf642x2d6yP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};